import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { OpcionSeleccionada } from "../types";
import { setVehiculoMarca, clearVehiculoMarca } from "../actions";
import { makeStyles } from "@mui/styles";
import VehiculoMarcaSelector from "../../../business/vehiculoMarcaSelector/VehiculoMarcaSelector";
import MulticotizadorContent from "./MulticotizadorContent";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    marcaSelected: state.marcaSelected,
  }));

const MarcaStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { marcaSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearVehiculoMarca());
  }, [dispatch]);

  const handleChange = (event: { target: { value: OpcionSeleccionada } }) => {
    dispatch(setVehiculoMarca(event.target.value));
  };

  return (
    <MulticotizadorContent>
      <div className={classes.title}>
        <PrimaryTitle
          label="Ingresá la marca del vehículo del asegurado"
          marginBottom={32}
        />
      </div>
      <VehiculoMarcaSelector value={marcaSelected} onChange={handleChange} />
    </MulticotizadorContent>
  );
});

export default MarcaStep;
